import objectFitImages from 'object-fit-images';
import moment from 'moment';

moment.locale('ru');

export const onInitialClientRender = () => {
  objectFitImages();
};
